/**
 * Simple Text Input with placeholder
 */

import { forwardRef } from 'react'
import styled from 'styled-components'
import { typography } from 'styled-system'
import BaseTextInput from './BaseTextInput'
import { BaseTextInputProps } from './types'
import { Container } from './style'

export interface BoxlessProps {
  showBorderOnFocus?: boolean
}

const BoxlessTextInput = forwardRef<HTMLInputElement, BaseTextInputProps & BoxlessProps>(
  ({ inline = false, width = 'auto', showError = true, showXPadding = true, ...props }, ref) => (
    <Container inline={inline}>
      <TextInput ref={ref} inline={inline} width={width} showError={showError} showXPadding={showXPadding} {...props} />
    </Container>
  ),
)

const TextInput = styled(BaseTextInput)<BaseTextInputProps & BoxlessProps>`
  ${typography}
  background-color: ${(p) => (p.disabled ? p.theme.colors.gray1 : p.theme.colors.white)};
  border: none;
  display: ${(p) => (p.inline ? 'inline-block' : 'block')};
  padding-left: ${(p) => (p.showXPadding ? (p.icon && p.iconPosition === 'left' ? '40px' : '16px') : '0')};
  padding-right: ${(p) => (p.showXPadding ? (p.icon && p.iconPosition === 'right' ? '40px' : '16px') : '0')};
  outline: ${(p) => (p.error || p.isError ? '1px solid red' : 'none')};

  ::placeholder {
    ${(p) => p.theme.font({ color: 'gray5' })}
  }

  &:disabled {
    ${(p) => p.theme.font({ color: p.readOnly ? 'defaultText' : 'disabledText' })}
  }

  &:hover {
    outline: ${(p) =>
      p.error || p.isError ? '1px solid red' : p.showBorderOnFocus ? `1px solid ${p.theme.colors.blue5}` : 'none'};
  }

  &:active,
  &:focus {
    ${(p) =>
      !p.disabled &&
      !p.readOnly &&
      `
        background-color: ${p.designVersion == 'v1' ? p.theme.colors.white : p.theme.colors.gray1}; 
        color: ${p.theme.colors.defaultText};
      `}
    outline: ${(p) =>
      p.error || p.isError ? '1px solid red' : p.showBorderOnFocus ? `1px solid ${p.theme.colors.blue1}` : 'none'};
  }

`

export default BoxlessTextInput
